import PropTypes from 'prop-types';
import { Calendar } from '@nivo/calendar';
import { useTheme } from 'react-admin';
import { Canvg } from 'canvg';
import { saveAs } from 'file-saver';
import { useRef } from 'react';
import { Button, ButtonGroup } from '@mui/material';

export const CalendarGraph = ({ data, ...rest }) => {
  const theme = useTheme();
  const isDarkMode = (theme?.[0]?.palette?.mode || theme?.[0]) === 'dark';
  const textColor = isDarkMode ? 'white' : 'black';
  const gridColor = isDarkMode ? 'black' : 'white';
  const tooltipBackground = isDarkMode ? 'black' : 'white';
  const tooltipTextColor = isDarkMode ? 'white' : 'black';

  const chartRef = useRef(null);

  const downloadSVGAsPNG = () => {
    if (chartRef.current) {
      const svg = chartRef.current.querySelector('svg');
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const v = Canvg.fromString(ctx, svg.outerHTML);
      v.render().then(() => {
        canvas.toBlob(blob => {
          saveAs(blob, 'chart.png');
        });
      });
    }
  };

  const downloadSVG = () => {
    if (chartRef.current) {
      const svg = chartRef.current.querySelector('svg');
      const serializer = new XMLSerializer();
      const svgBlob = new Blob([serializer.serializeToString(svg)], {
        type: 'image/svg+xml'
      });
      saveAs(svgBlob, 'chart.svg');
    }
  };

  const downloadDataAsCSV = () => {
    let csv = Object.keys(data[0]).join(',') + '\n';
    data.forEach(row => {
      csv += Object.values(row).join(',') + '\n';
    });
    const blob = new Blob([csv], { type: 'text/csv' });
    saveAs(blob, 'data.csv');
  };

  return (
    <div
      style={{ textAlign: 'center', width: '100%', height: '100%' }}
      ref={chartRef}
    >
      <Calendar
        data={data}
        colors={{ scheme: isDarkMode ? 'dark2' : 'nivo' }}
        {...rest}
        theme={{
          axis: {
            ticks: {
              text: {
                fill: textColor
              }
            },
            legend: {
              text: {
                fill: textColor
              }
            }
          },
          grid: {
            line: {
              stroke: gridColor
            }
          },
          tooltip: {
            container: {
              background: tooltipBackground,
              color: tooltipTextColor
            }
          },
          legends: {
            text: {
              fill: textColor
            }
          },
          labels: {
            text: {
              fill: textColor
            }
          }
        }}
      />
      <ButtonGroup variant="contained" style={{ marginTop: '10px' }}>
        <Button onClick={downloadSVGAsPNG}>Download PNG</Button>
        <Button onClick={downloadSVG}>Download SVG</Button>
        <Button onClick={downloadDataAsCSV}>Download CSV</Button>
      </ButtonGroup>
    </div>
  );
};

CalendarGraph.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  ...Calendar.propTypes
};
